module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/sp/contacts/img_about01-e232b07e804c56bafbe9c6932fb889ae.png";